import { TitleComponent } from "../../components";

export const SettingLandingClaimHeaderContainer = () => {
  return (
    <section className="OrderDetailHeaderContainer">
      <div className="OrderDetailHeaderContainer__title">
        <TitleComponent title="Detalle del Reclamo" />
      </div>
    </section>
  );
};
